module.exports = __webpack_public_path__ + "img/progressico2white.b09091c7.png";